import axios from 'axios'

export default{
  namespaced: true,
  state: {
  },

  mutations: {
  },
  getters: {
  },
  actions: {
    async saveSubscription ({commit, state, rootState, dispatch}, subscription) {
      try {
        console.log('Saving subscription: ' + JSON.stringify(subscription, null, 2))
        await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/subscriptions`,
          {companyId: rootState.userCurrentCompany.companyId, subscription: subscription}
        ).then(data => {
          console.log('Data is: ' + data)
        })
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async getSubscriptions ({commit, state, rootState}) {
      console.log(`Getting subscriptions: /api/company/${rootState.userCurrentCompany.companyId}/subscriptions`)
      return axios.get(`/api/company/${rootState.userCurrentCompany.companyId}/subscriptions`)
        .then((result) => { return result.data.subscriptions })
        .catch((e) => { console.log(`Error: the server responded with '${e.response.status}: ${e.response.statusText}'`) })
    },
    async getSubscription ({commit, state, rootState}, subscriptionId) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/subscriptions/${subscriptionId}`)
      return axios.get(`/api/company/${rootState.userCurrentCompany.companyId}/subscriptions/${subscriptionId}`)
        .then((result) => { return result.data.subscription })
        .catch((e) => { console.log(`Error: the server responded with '${e.response.status}: ${e.response.statusText}'`) })
    },
    async deleteSubscription ({commit, state, rootState, dispatch}, subscription) {
      try {
        console.log('Deleting subscription: ' + JSON.stringify(subscription, null, 2))
        console.log(subscription.id)
        await axios.delete(
          `/api/company/${rootState.userCurrentCompany.companyId}/subscriptions/${subscription.id}`
        ).then(result => {
          // console.log('Data is: ' + result)
        })
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/companynotifications.js